"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WizardTypeName = void 0;
var WizardTypeName;
(function (WizardTypeName) {
    WizardTypeName["LOCATION_INSIGHTS"] = "Location Insights";
    WizardTypeName["CAMPAIGN_INSIGHTS"] = "Media Campaign Insights";
    WizardTypeName["CONSUMER_INSIGHTS"] = "Consumer Insights";
    WizardTypeName["MARKET_INSIGHTS"] = "Market Insights";
})(WizardTypeName || (exports.WizardTypeName = WizardTypeName = {}));
;
